import { render } from "./PimProductsOverviewTableItemPreview.vue?vue&type=template&id=97a81334&scoped=true&ts=true"
import script from "./PimProductsOverviewTableItemPreview.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewTableItemPreview.vue?vue&type=script&lang=ts"

import "./PimProductsOverviewTableItemPreview.vue?vue&type=style&index=0&id=97a81334&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a81334"]])

export default __exports__